export const emailValidatorRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;

export const dataRegexValidatior =
  /^([0]?[1-9]|[1|2][0-9]|[3][0|1])[./-]([0]?[1-9]|[1][0-2])[./-]([0-9]{4}|[0-9]{2})$/;
export const dataHoraRegexValidator =
  /^([0]?[1-9]|[1|2][0-9]|[3][0|1])[./-]([0]?[1-9]|[1][0-2])[./-]([0-9]{4}|[0-9]{2}) ([0-1]?[0-9]|[2][0-3]):([0-5][0-9])$/;

export const required = (v) => !!v || "O campo é obrigatório";
export const requiredBoolean = (v) => {
  if (v !== true && v !== false) return "O campo é obrigatório";

  return true;
};

export const requiredArray = (v) => {
  if (!v.length) return "O campo é obrigatório";
  return true;
};

export const emailValidator = (v) => {
  if (emailValidatorRegex.test(v)) {
    return true;
  }

  return "Email inválido";
};
